export default "__VITE_ASSET__BK9CZdk2__"